export class BulkRestoreValidateRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<BulkRestoreItem>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkRestoreValidateRequest.attributeTypeMap;
    }
    constructor() {
    }
}
